import { useEffect, useState } from "react";
import axios from "axios";
import { Bell, Mail, MessageCircle, CheckCircle2, Clock3, CircleAlert } from "lucide-react";
import { API } from "../lib/api";

const eventLabel = { submitted: "Pengajuan baru", resubmitted: "Pengajuan diajukan ulang", updated: "Pengajuan diperbarui", review_request: "Permintaan tinjauan", approved: "Pengajuan disetujui", rejected: "Pengajuan ditolak", reminder: "Pengingat tinjauan", profile_updated: "Profil diperbarui", password_changed: "Kata sandi diubah", password_reset: "Kata sandi diatur ulang", settings_updated: "Pengaturan diperbarui", monthly_report: "Laporan bulanan" };
const emailStatus = {
  in_app_only: ["Notifikasi dalam aplikasi", "muted"],
  sent: ["Email terkirim", "sent"],
  queued: ["Email sedang diproses", "queued"],
  failed: ["Email gagal dikirim", "failed"],
  not_configured: ["Email belum dikonfigurasi", "failed"],
  opted_out: ["Pengiriman email dimatikan", "muted"],
  no_email: ["Email pengguna belum tersedia", "muted"],
};
const whatsappStatus = {
  sent: ["Diterima API WhatsApp", "sent"],
  failed: ["WhatsApp gagal dikirim", "failed"],
  not_configured: ["WhatsApp belum dikonfigurasi", "muted"],
  no_phone: ["Nomor WhatsApp belum diisi", "muted"],
  opted_out: ["Belum menyetujui notifikasi WhatsApp", "muted"],
};

export default function Notifications({ user }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    let active = true;
    const load = async (dispatchUpdate = false) => {
      setError("");
      try {
        const { data } = await axios.get(`${API}/notifications`);
        if (!active) return;
        setItems(data);
        const unreadIds = data.filter(item => item.is_read !== true).map(item => item.id);
        if (unreadIds.length) {
          try {
            await axios.post(`${API}/notifications/read`, { ids: unreadIds });
            if (active) setItems(current => current?.map(item => unreadIds.includes(item.id) ? { ...item, is_read: true } : item));
          } catch { /* Keep the unread indicator if marking read fails. */ }
        }
        if (dispatchUpdate) window.dispatchEvent(new Event("notifications-updated"));
      } catch {
        if (active) { setItems([]); setError("Notifikasi gagal dimuat. Periksa koneksi lalu coba lagi."); }
      }
    };
    load(true);
    const refresh = () => load();
    const timer = window.setInterval(refresh, 30000);
    window.addEventListener("notifications-updated", refresh);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("notifications-updated", refresh); };
  }, [user.id, reloadKey]);
  return <>
    <div className="page-heading"><div><p className="eyebrow">PUSAT PEMBERITAHUAN</p><h1>Notifikasi</h1><p className="muted">Riwayat pemberitahuan dalam aplikasi, email, dan WhatsApp.</p></div></div>
    <section className="section-panel"><div className="section-head"><div><h2>Riwayat notifikasi</h2><p className="muted">{items ? `${items.length} notifikasi` : "Memuat..."}</p></div></div>
      <div className="notification-list" data-testid="notification-list">
        {error && <div className="empty-state">{error}<button type="button" className="secondary-btn" onClick={() => setReloadKey(value => value + 1)}>Coba lagi</button></div>}
        {!error && items?.length === 0 && <div className="empty-state">Belum ada notifikasi</div>}
        {!error && items?.map(n => {
          const [label, tone] = emailStatus[n.email_status] || (n.status === "simulated" ? ["WhatsApp belum tersambung", "muted"] : ["Status email tidak tersedia", "muted"]);
          const StatusIcon = tone === "sent" ? CheckCircle2 : tone === "queued" ? Clock3 : tone === "failed" ? CircleAlert : Mail;
          const [waLabel, waTone] = whatsappStatus[n.whatsapp_status] || ["Status WhatsApp tidak tersedia", "muted"];
          const WhatsappIcon = waTone === "sent" ? CheckCircle2 : waTone === "failed" ? CircleAlert : MessageCircle;
          return <article className="notification-item" key={n.id} data-testid={`notification-${n.id}`}>
            <div className="notification-icon"><Bell size={17} /></div>
            <div className="notification-content">
              <div className="notification-meta"><strong>{eventLabel[n.event] || "Pemberitahuan"}</strong><span>{n.to_name}</span><em>{new Date(n.created_at).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</em></div>
              <p>{n.message}</p>
              <small className={`notification-email-status ${tone}`}><StatusIcon size={13} />{label}</small>
              <small className={`notification-email-status ${waTone}`}><WhatsappIcon size={13} />{waLabel}</small>
            </div>
          </article>;
        })}
      </div>
    </section>
  </>;
}
